import { notifyError } from "utils";
import { dispatch } from "store/store";
import { project as constants } from "store/constants";
import { actionLoaderFactory } from "store/factories/fetchable";
import { IS_DEV } from "globals/constants";
import { api } from "services";


const factory = actionLoaderFactory(constants, constants.SINGLE_PROJECT);

const resetProject = () => dispatch({ type: constants.SINGLE_PROJECT_RESET });

const getProject = async (projectId, options = { isRefresh: false }) => {
	return factory.createLoaderAction(
		() => api.project.get(projectId),
		[
			(response) => {
				factory.setData({ project: response });

				return response;
			},
			(error, { getState }) => {
				const message = IS_DEV ? error.message : getState().dictionary.projects.errors.projectFailedLoad;

				notifyError(message, error);
				factory.setError(message);
			},
		],
		options,
	);
};

export {
	getProject,
	resetProject,
};
